import { render, staticRenderFns } from "./FbNetworkTab.vue?vue&type=template&id=1d59dc9a"
import script from "./FbNetworkTab.vue?vue&type=script&lang=ts"
export * from "./FbNetworkTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports